import Fire from './Fire';
import Snow from './Snow';
import Water from './Water';
import Sun from './Sun';

export default {
  Fire,
  Snow,
  Water,
  Sun
};